import D4 from "modules/ebiForms/definitions/D4";
import D5 from "modules/ebiForms/definitions/D5";
import D6 from "modules/ebiForms/definitions/D6";
import D7 from "modules/ebiForms/definitions/D7";
import D8 from "modules/ebiForms/definitions/D8";
import E5 from "modules/ebiForms/definitions/E5";
import E6 from "modules/ebiForms/definitions/E6";
import E7 from "modules/ebiForms/definitions/E7";
import { IEbiFormDefinition } from "modules/ebiForms/typings";

/** Oświata, parkowanie i straż gminna: D4, D5, D6, D7, D8, E5, E6, E7 (docs/magistrat/ebi-wnioski). */
const FORMS: IEbiFormDefinition[] = [D4, D5, D6, D7, D8, E5, E6, E7];

export default FORMS;
